import { SvgIcon, SxProps, Theme, css, styled } from '@mui/material'

import { Tooltip } from '~/core/components/tooltip'
import { textOverflow } from '~/core/styles'
import { GuildDataBlockDefinition } from '~/features/guild/types'

import { ReactComponent as QuestionIcon } from '/assets/icons/icon-question.svg'

const TitleWrapper = styled('h3')`
  font-size: 18px;
  line-height: 20px;
  font-weight: bold;
  display: inline-flex;
  align-items: center;
  margin: 0;
  white-space: break-spaces;
`

const Title = styled('span')(
  ({ theme }) => css`
    ${textOverflow('auto')}
    height: 20px;
    color: ${theme.palette.text.primary};
    margin-right: 10px;
    &::before {
      content: '';
      display: inline-block;
      width: 5px;
      height: 100%;
      margin-right: 10px;
      background-color: ${theme.palette.text.primary};
      vertical-align: top;
    }
  `
)

const SuffixTitle = styled('span')`
  ${textOverflow('auto')}
  margin-left: 6px;
  ${({ theme }) => css`
    color: ${theme.palette.text.secondary};
  `}
`

const GuildTooltip = (props: { tooltipContents?: GuildDataBlockDefinition[] }) => {
  if (props.tooltipContents) {
    return (
      <Tooltip
        content={props.tooltipContents.map(
          (block, index) =>
            block && (
              <p key={index}>
                <b>{block.name}：</b>
                {block.description}
              </p>
            )
        )}
        self={
          <SvgIcon
            inheritViewBox
            component={QuestionIcon}
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
            }}
          />
        }
      />
    )
  }

  return <></>
}

const GuildTooltipTitle = (props: { tooltipTitle?: string }) => {
  if (props.tooltipTitle) {
    return <SuffixTitle>{props.tooltipTitle}</SuffixTitle>
  }

  return <></>
}

export const GuildTitle = (props: {
  title: string
  tooltipTitle?: string
  tooltipContents?: GuildDataBlockDefinition[]
  sx?: SxProps<Theme>
}) => (
  <TitleWrapper sx={props.sx}>
    <Title>{props.title}</Title>
    <GuildTooltip tooltipContents={props.tooltipContents} />
    <GuildTooltipTitle tooltipTitle={props.tooltipTitle} />
  </TitleWrapper>
)

export const DataBlocksTitle = styled('div')`
  display: flex;
  align-items: center;
  gap: 1rem;
  height: 40px; /* 保持和带按钮的 TableTitle 组件一样的高度 */
`

export const TableTitle = styled('div')`
  display: flex;
  align-items: center;
  gap: 1rem;
  height: 40px;
`
